// src/pages/TermsAndConditionsPage.js
import React from 'react';
import termsConditionsContent from '../../config/termsConditionsContent'; // Import the T&C content
import './TermsAndConditions.css'

const TermsAndConditionsPage = () => {
  return (
<div className="terms-container">
<h1 className="terms-h1">{termsConditionsContent.title}</h1>
      
      {/* Map through the sections and display the content dynamically */}
      {termsConditionsContent.sections.map((section, index) => (
        <div key={index} className="terms-section">
          <h2 className="terms-h2">{section.heading}</h2>
          <p className="terms-p">{section.content}</p>
        </div>
      ))}
    </div>
  );
};

export default TermsAndConditionsPage;
